import { render } from "./FormBuilderQuestions.vue?vue&type=template&id=27138b89&scoped=true"
import script from "./FormBuilderQuestions.vue?vue&type=script&lang=js"
export * from "./FormBuilderQuestions.vue?vue&type=script&lang=js"

import "./FormBuilderQuestions.vue?vue&type=style&index=0&id=27138b89&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27138b89"]])

export default __exports__